// Billing provider of the logged customer ("stripe" for US customers, backend #1818).
//
// Same mechanics as sugestoes-conteudo.js: the menu is built before any screen answers, so the
// login response is cached here. Unknown means "not Stripe" — Brazilian customers never see the
// billing menu item.
import apiClient from "@/services/api-base";

const STORAGE_KEY = "mention.billingProvider";

export const BILLING_STRIPE = "stripe";

export const setBillingProvider = (value) => {
  if (value) localStorage.setItem(STORAGE_KEY, value);
  else localStorage.removeItem(STORAGE_KEY);
};

export const isStripeBilling = () => localStorage.getItem(STORAGE_KEY) === BILLING_STRIPE;

// Opens the Stripe Customer Portal (payment method, invoices, cancellation) for the logged customer.
export const openBillingPortal = async () => {
  const { data } = await apiClient.post("billing/portal-session", {});
  window.location.href = data.url;
};
